import { CalendarClock, ChartNoAxesCombined, ContactRound, FolderOpen, ListChecks, MessageSquare, Network, Route, ShieldCheck, Smartphone, Sparkles, Users } from "lucide-react";
import { Reveal, SectionHeading } from "../components/Reveal";
import NetworkViz from "../components/NetworkViz";
import { useSectionNavigation } from "../lib/navigation";

const CONTROL_ICONS = [
  { key: "list-checks", Icon: ListChecks, label: "ATTIVITÀ" },
  { key: "folder-open", Icon: FolderOpen, label: "DOCUMENTI" },
  { key: "users", Icon: Users, label: "PROFESSIONISTI" },
  { key: "calendar-clock", Icon: CalendarClock, label: "SCADENZE" },
  { key: "message-square", Icon: MessageSquare, label: "COMUNICAZIONI" },
  { key: "chart-no-axes-combined", Icon: ChartNoAxesCombined, label: "AVANZAMENTO" },
];

const WHY_ICONS = [
  { key: "route", Icon: Route, label: "5 PROTOCOLLI", copy: "Un metodo strutturato per ogni obiettivo." },
  { key: "smartphone", Icon: Smartphone, label: "PORTALE DEDICATO", copy: "Il percorso sempre sotto controllo, ovunque." },
  { key: "sparkles", Icon: Sparkles, label: "ASSISTENTE IA 24/7", copy: "Assistenza contestuale in ogni fase." },
  { key: "network", Icon: Network, label: "PROFESSIONISTI SELEZIONATI", copy: "Competenze integrate nella rete." },
  { key: "shield-check", Icon: ShieldCheck, label: "CONTROLLO OPERATIVO", copy: "Attività e percorso coordinati." },
  { key: "contact-round", Icon: ContactRound, label: "UNICO REFERENTE", copy: "Un punto di riferimento, sempre." },
];

export function EcosistemaSection() {
  const goToSection = useSectionNavigation();
  return (
    <section id="ecosistema" className="section" data-testid="ecosistema-section">
      <div className="container-hub grid items-center gap-14 lg:grid-cols-[0.9fr_1.1fr]">
        <div>
          <SectionHeading
            eyebrow="L'ecosistema"
            title={<>NON UN ELENCO DI PROFESSIONISTI. <span className="gold-text">UNA RETE SELEZIONATA.</span></>}
            lead="A.C. HUB coordina professionisti selezionati secondo il percorso e le necessità del cliente. Nessun nome a caso: le competenze giuste, al momento giusto."
          />
          <Reveal delay={0.25}>
            <button
              data-testid="ecosistema-partner-cta"
              onClick={() => goToSection("diventa-partner")}
              className="btn btn-gold mt-8"
            >
              Sei un professionista? Entra nella rete
            </button>
          </Reveal>
        </div>
        <Reveal delay={0.15}>
          <NetworkViz
            small
            center="A.C. HUB"
            testidPrefix="ecosistema"
            nodes={["TECNICI", "ARCHITETTI", "IMPRESE", "CONSULENTI", "NOTAI", "PROFESSIONISTI"]}
          />
        </Reveal>
      </div>
    </section>
  );
}

export function ControlloSection() {
  return (
    <section id="controllo" className="section" data-testid="controllo-section">
      <div className="container-hub">
        <SectionHeading
          eyebrow="Controllo operativo"
          title={<>UN PERCORSO COMPLETO. <span className="gold-text">UNA REGIA UNICA.</span></>}
          lead="Il cliente non deve inseguire nessun interlocutore: A.C. HUB mantiene la regia del percorso su ogni piano operativo."
          center
        />
        <div className="mt-14 grid grid-cols-2 gap-3 md:grid-cols-3 lg:grid-cols-6">
          {CONTROL_ICONS.map(({ key, Icon, label }, i) => (
            <Reveal key={key} delay={i * 0.06}>
              <div
                className="card-hub group flex min-h-[150px] flex-col justify-between p-5"
                data-testid={`control-item-${key}`}
              >
                <Icon size={18} strokeWidth={1.5} className="text-gold transition-transform duration-300 group-hover:-translate-y-1" />
                <span className="text-[10px] font-bold tracking-[0.14em] text-cream">
                  {label}
                </span>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}

export function PercheSection() {
  return (
    <section id="perche" className="section" data-testid="perche-section">
      <div className="container-hub">
        <SectionHeading
          eyebrow="Perché A.C. HUB"
          title={<>UN SISTEMA PENSATO PER TE.</>}
          lead="Non un servizio in più: la regia che tiene insieme tutto il resto."
          center
        />
        <div className="mt-14 grid grid-cols-1 border border-[#c9a45c]/22 bg-[#c9a45c]/22 sm:grid-cols-2 lg:grid-cols-3">
          {WHY_ICONS.map(({ key, Icon, label, copy }, i) => (
            <Reveal key={key} delay={i * 0.06} className="bg-[#0b0b0b]">
              <div className="min-h-[190px] p-7 transition-colors duration-300 hover:bg-[#111]" data-testid={`why-item-${key}`}>
                <Icon size={19} strokeWidth={1.5} className="text-gold" />
                <h3 className="mt-6 text-[12px] font-bold tracking-[0.12em] text-cream">
                  {label}
                </h3>
                <p className="mt-2 text-[13px] leading-relaxed text-[#929292]">
                  {copy}
                </p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
